<template>
    <div class="ssv-form">
        <div class="input-item">
            <label class="label" for="name">Název stavby</label>
            <input class="input input--l" type="text" id="name" v-model="name"/>
            <ssv-order-error-field field="buildingCertification.name"/>
        </div>

        <div class="input-item">
            <label class="label" for="address">Adresa</label>
            <input class="input input--xl" type="text" id="address" v-model="address"/>
            <ssv-order-error-field field="buildingCertification.address"/>
        </div>

        <div class="input-item">
            <label class="label" for="city">Město</label>
            <input class="input input--l" type="text" id="city" v-model="city">
            <ssv-order-error-field field="buildingCertification.city"/>
        </div>

        <div class="input-item">
            <label class="label" for="realizationDate">Termín realizace (od - do)</label>
            <input class="input input--l" type="text" id="realizationDate" v-model="realizationDate"/>
            <ssv-order-error-field field="buildingCertification.realizationDate"/>
        </div>

        <div class="input-item">
            <label class="label" for="expiredCertificateEvidenceNumber">Číslo propadlého certifikátu</label>
            <input class="input input--l" type="text" id="expiredCertificateEvidenceNumber" v-model="expiredCertificateEvidenceNumber"/>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {mapFields} from 'vuex-map-fields';
    import SsvOrderErrorField from '../error/ErrorField';

    export default {
        name: 'SsvOrderBuildingCertificationForm',
        components: {
            SsvOrderErrorField
        },
        computed: {
            ...mapFields('ssvOrder', [
                'buildingCertification.name',
                'buildingCertification.address',
                'buildingCertification.city',
                'buildingCertification.realizationDate',
                'buildingCertification.expiredCertificateEvidenceNumber',
            ]),
        },
        methods: {
            ...mapActions('ssvOrder', ['setError']),
            validate() {
                if (!this.name || this.name.length === 0) this.setError({
                    msg: 'Zadejte název stavby',
                    key: 'buildingCertification.name'
                });
                if (!this.address || this.address.length === 0) this.setError({
                    msg: 'Zadejte adresu',
                    key: 'buildingCertification.address'
                });
                if (!this.city || this.city.length === 0) this.setError({
                    msg: 'Zadejte město',
                    key: 'buildingCertification.city'
                });
                if (!this.realizationDate || this.realizationDate.length === 0) this.setError({
                    msg: 'Zadejte termín realizace',
                    key: 'buildingCertification.realizationDate'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/building-certification/BuildingCertificationForm.vue